var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.model.disabled)?_c('resolver',{attrs:{"model":_vm.model}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }